import {
	reConstructionCategoryConstants
}from "./constants"
import actions from '../../../actions'

const initialState = {
	error      : null,
	isSending  : false,
	kinds      : [],
	list       : null,
	volumeList : null,
	childs     : null,
	find       : null,
	changed    : null,
	paged      : {},
	pagedAudit : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case (reConstructionCategoryConstants.GetKinds.REQUEST):
		case (reConstructionCategoryConstants.GetList.REQUEST):
		case (reConstructionCategoryConstants.GetChilds.REQUEST):
		case (reConstructionCategoryConstants.Find.REQUEST):
		case (reConstructionCategoryConstants.create.REQUEST):
		case (reConstructionCategoryConstants.delete.REQUEST):
		case (reConstructionCategoryConstants.update.REQUEST):
		case (reConstructionCategoryConstants.restore.REQUEST):
		case (reConstructionCategoryConstants.getPagedAll.REQUEST):
		case (reConstructionCategoryConstants.getPagedAudit.REQUEST):
		case (reConstructionCategoryConstants.GetVolumeList.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}

		case (reConstructionCategoryConstants.getPagedAll.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (reConstructionCategoryConstants.getPagedAudit.SUCCESS):
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result
			}
		case (reConstructionCategoryConstants.GetKinds.SUCCESS):
			return {
				...state,
				isSending	: false,
				kinds    	: action.payload.result
			}
		case (reConstructionCategoryConstants.GetChilds.SUCCESS):
			return {
				...state,
				isSending	: false,
				childs   	: action.payload.result
			}
		case (reConstructionCategoryConstants.GetList.SUCCESS):

			return {
				...state,
				isSending	: false,
				list     	: action.payload.result
			}
		case (reConstructionCategoryConstants.GetVolumeList.SUCCESS):
			return {
				...state,
				isSending 	: false,
				volumeList	: action.payload.result
			}

		case (reConstructionCategoryConstants.Find.SUCCESS):
			return {
				...state,
				isSending	: false,
				find     	: action.payload.result
			}
		case (reConstructionCategoryConstants.GetKinds.FAILURE):
		case (reConstructionCategoryConstants.GetList.FAILURE):
		case (reConstructionCategoryConstants.GetChilds.FAILURE):
		case (reConstructionCategoryConstants.Find.FAILURE):
		case (reConstructionCategoryConstants.create.FAILURE):
		case (reConstructionCategoryConstants.delete.FAILURE):
		case (reConstructionCategoryConstants.update.FAILURE):
		case (reConstructionCategoryConstants.restore.FAILURE):
		case (reConstructionCategoryConstants.getPagedAll.FAILURE):
		case (reConstructionCategoryConstants.getPagedAudit.FAILURE):
		case (reConstructionCategoryConstants.GetVolumeList.FAILURE):
			return {
				...state,
				isSending	: false,
				error    	: action.payload
			}
		case (reConstructionCategoryConstants.create.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : 'Категория успешно добавлена.'
			}
		}
		case (reConstructionCategoryConstants.delete.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : 'Категория успешно удалена.'
			}
		}
		case (reConstructionCategoryConstants.update.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : 'Категория успешно изменена.'
			}
		}
		case (reConstructionCategoryConstants.restore.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : 'Категория успешно восстановлена.'
			}
		}

		case (reConstructionCategoryConstants.CLEAR):
			return {
				...state,
				error      : null,
				isSending  : false,
				kinds      : [],
				list       : null,
				childs     : null,
				find       : null,
				paged      : {},
				pagedAudit : {}
			}
		default:
			return state
	}
}